/**
 * @param {String} direction - up or down
 * @param {Array} items - array containing the dropdown items
 * @param {HTMLElement} currentFocusedItem - which has focus now
 */
export const traverse = (direction, items, currentFocusedItem) => {
    // eslint-disable-next-line init-declarations
    let nextFocusedItem;

    // eslint-disable-next-line no-negated-condition
    if (!currentFocusedItem) {
        // eslint-disable-next-line no-magic-numbers
        nextFocusedItem = items[0];
    } else {
        nextFocusedItem = currentFocusedItem[direction === 'up' ? 'previousElementSibling' : 'nextElementSibling'];
    }

    if (nextFocusedItem) {
        nextFocusedItem.focus();
    }
};
